import { Component, Input, Output, EventEmitter, AfterViewInit  } from '@angular/core';

import { InputParameter } from '../entities/InputParameters';
import { Datavalue } from '../entities/Datavalue';
import { TableOptions } from '../entities/TableOptions';
import { Condition } from '../entities/Condition';
import { VernostService } from '../../services/app.service';
import { datarows } from '../entities/DataRows';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-model-input',
  templateUrl: './model-input.component.html',
  styleUrls: ['./model-input.component.scss'],
  providers: [VernostService]
})

export class ModelInputComponent implements AfterViewInit {

  fieldparam: InputParameter;
  pcombodata: any = [];
  @Input('combodata')
  set combodata(data: any) {
    this.pcombodata = data;
  }
  get combodata() {
    return this.pcombodata;
  }

  ngAfterViewInit(){
    
  }

  @Input('field')
  set field(val: InputParameter) {
    console.log("fieldparam",this.fieldparam);
    this.fieldparam = val;
    this.fieldparam.isvalid = true;
    this.fieldparam.datavalues=[];
  }
  @Output('change') afterchange: EventEmitter<any> = new EventEmitter<any>();
  @Output('keyup') keyup: EventEmitter<any> = new EventEmitter<any>();
  //readonly
  options: FormGroup;

  constructor(fb: FormBuilder, private mainService: VernostService) {
    this.options = fb.group({
      hideRequired: false,
      floatLabel: 'auto',
    });
  }

  dropdownSettings = {
    singleSelection: false,
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class'
  };
  dropdownList:any=[];

  ngOnInit() {
    if (this.fieldparam.compname === 'multiselect') {
      this.dropdownSettings.text=this.fieldparam.title;
    }
    // console.log(this.fieldparam.style);

    // if (this.fieldparam.compname == "combobox" && this.fieldparam.combo_search_proce != "") {
    //   this.fillcombodata(this.fieldparam);
    // }
    // if (this.fieldparam.compname == "combobox" && this.fieldparam.list != "") {
    //   this.fillstaticcombodata();
    // }
    // if (this.fieldparam.compname == "checkbox" && this.fieldparam.value == null) {
    //   this.fieldparam.value = false;
    // }
    // if (this.fieldparam.compname == "autocomplete" && this.fieldparam.value != null) {
    //   this.setAutoCompleteData();
    // }
    // if (this.fieldparam.compname == "multipledropdown" && this.fieldparam.value != null) {
    //   this.setMultiSelectData();
    // }
  }

  // combobox with table data

  fillcombodata(listparam: any) {
    let tableoption: TableOptions = new TableOptions();
    let conditions: Condition[] = [];

    if (listparam.combo_filter != null || listparam.combo_filter != "") {
      let strfltr = listparam.combo_filter.replace(" ", "");
      strfltr = strfltr.toLowerCase();
      let splitdata = strfltr.split("and");

      splitdata.forEach((element: any) => {
        let tmpdata: string[] = element.split("=");
        if (tmpdata.length == 2) {
          conditions.push(new Condition(tmpdata[0], tmpdata[1]));
        }
      });
    }

    tableoption.conditions = conditions;
    let cols: string[] = [];
    cols.push(listparam.combo_disp_field);
    cols.push(listparam.combo_value_field);

    tableoption.tablecols = cols;
    // this.mainService.getTableData('hamse', listparam.combo_search_proce, tableoption).subscribe(
    //   response => {
    //     let datarow: datarows[] = response.datarows;
    //     listparam.datavalues = [];

    //     for (let data of datarow) {
    //       let d: datarows = new datarows();
    //       let datavalue: Datavalue = new Datavalue();

    //       for (let col of data.cols) {
    //         if (col.fieldName != listparam.combo_value_field) {
    //           datavalue.pvalue = col.value;
    //         }
    //         else {
    //           datavalue.pname = col.value;
    //         }
    //       }
    //       listparam.datavalues.push(datavalue);
    //     }
    //   });
  }

  // combobox with static data

  fillstaticcombodata() {
    let combodata: string[] = this.fieldparam.list.split(",");
    this.fieldparam.datavalues = [];

    combodata.forEach(element => {
      let id: string = element;
      let value: string = element;

      if (element.indexOf(":") > 0) {
        let d: string[] = element.split(":");
        id = d[0];
        value = d[1];
      }
      let datavalue: Datavalue = new Datavalue();
      datavalue.pname = id;
      datavalue.pvalue = value;
      this.fieldparam.datavalues.push(datavalue);
    });
  }

  // search autocomplete data

  results: string[] = [];

  searchData(event: any) {
    let autocompleteText = event.query;

    // if (this.fieldparam.combo_search_proce != "") {
    //   let tableoption: TableOptions = new TableOptions();
    //   let conditions: Condition[] = [];
    //   conditions.push(new Condition(this.fieldparam.combo_disp_field, "%" + autocompleteText + "%"));

    //   tableoption.conditions = conditions;
    //   tableoption.limit = 10;

    //   let cols: string[] = [];
    //   cols.push(this.fieldparam.combo_disp_field);
    //   cols.push(this.fieldparam.combo_value_field);
    //   tableoption.tablecols = cols;

    //   // this.mainService.getTableValues('hamse', this.fieldparam.combo_search_proce, tableoption).subscribe(
    //   //   response => {
    //   //     console.log("autocomplete search response === ", response);
    //   //     this.results = response;
    //   //   });
    // }
  }

  setData(event: any) {
    console.log(event[this.fieldparam.combo_value_field]);
  }

  // set autocomplete data

  setAutoCompleteData() {
    this.fieldparam.value = {
      [this.fieldparam.combo_value_field]: this.fieldparam.value
    };
  }

  // set multiselect data

  setMultiSelectData() {
    let tableoption: TableOptions = new TableOptions();

    let cols: string[] = [];
    cols.push(this.fieldparam.combo_disp_field);
    cols.push(this.fieldparam.combo_value_field);
    tableoption.tablecols = cols;

    tableoption.limit = 10;

    let customCondition = "";

    this.fieldparam.value.forEach((element: any) => {
      customCondition = customCondition + element + ",";
    });

    customCondition = customCondition.substr(0, (customCondition.length - 1));
    tableoption.additionslfilter = this.fieldparam.combo_value_field + " IN (" + customCondition + ")";

    // this.mainService.getTableValues('hamse', this.fieldparam.combo_search_proce, tableoption).subscribe(
    //   response => {
    //     console.log("multiselect oninit response === ", response);
    //     this.fieldparam.value = response;
    //   });
  }

  // remove multiselect item

  removeMultiselectItem(item: any) {
    console.log(item[this.fieldparam.combo_value_field]);

    // if (this.fieldparam.editable != "1") {
    //   for (let i = 0; i < this.fieldparam.value.length; i++) {
    //     let element = this.fieldparam.value[i];

    //     if (element[this.fieldparam.combo_value_field] == item[this.fieldparam.combo_value_field]) {
    //       this.fieldparam.value.splice(i, 1);
    //     }
    //   }
    // }
  }

  // fileupload / imageupload

  uploadFile() {
    // let uploadFile = (<HTMLInputElement>window.document.getElementById(this.fieldparam.dbfield)).files[0];

    // if (uploadFile != undefined) {
    //   this.mainService.uploadFile(uploadFile).subscribe(
    //     (response: any) => {
    //       console.log("uploadFile response === ", response.message);
    //       console.log("uploadFile response === ", response.path);

    //       // this.fieldparam.value = response.path;
    //       this.fieldparam.value = "http://10.10.10.51:8888" + response.path;
    //     });
    // }
  }

  // download file

  downloadFile(event: any, filePath: any) {
    console.log("filePath === ", filePath);

    filePath = filePath.substring(23);

    let target = event.target || event.srcElement || event.currentTarget;
    let idAttr = target.attributes.id;
    let value = idAttr.nodeValue;
    let downloadfile = <HTMLAnchorElement>document.getElementById(value);

    downloadfile.href = filePath;
  }

  // html editor

  onEditorChange(event: any) {
    this.fieldparam.value = event;
  }

  // set dynamic styles

  // getStyles() {
  //   let styleJson = {};
  //   let mystyles = this.fieldparam.style.split(";");

  //   mystyles.forEach((element: any) => {
  //     let arr = [];
  //     arr = element.split(":");

  //     styleJson[arr[0]] = arr[1];
  //   });

  //   return styleJson;
  // }

  // get date value

  writeDateValue(value: string) {
    if (value == '' || value == null) {
      return '';
    }
    else {
      let vl: any = this.checkdate(value);
      this.fieldparam.value = vl;
      return vl;
    }
  }

  private checkdate(value: string) {
    let dt: Date = new Date(value);
    let fordate: string = dt.getFullYear() + "-" + this.getMonth(dt.getMonth()) + "-" + this.getDay(dt.getDate());
    return fordate;
  }

  private getDay(day: number) {
    let d: string = day + "";

    if (d.length == 1) {
      return "0" + d;
    }
    else {
      return d;
    }
  }

  private getMonth(month: number) {
    let mn: string = (month + 1) + "";

    if (mn.length == 1) {
      return "0" + mn;
    }
    else {
      return mn;
    }
  }

  // set date value

  setDateValue(element: any) {
    let inputtext = (<HTMLInputElement>window.document.getElementById(this.fieldparam.dbfield));
    this.fieldparam.value = inputtext.value;
  }

  validatechangeevent(data: any) {
    this.fieldparam.isvalid = true;
    console.log(data.target.value, this.fieldparam.length)
    if (this.mainService.checkUndefined(this.fieldparam.length) != "") {
      if (data.target.value != "") {
        if (data.target.value.length > this.fieldparam.length) {
          this.mainService.showmessaage("Value too long, Max " + this.fieldparam.length + " characters required");
          this.fieldparam.isvalid = false;
        }
      }
    }
    if (this.fieldparam.unique) {
      if (this.mainService.checkUndefined(this.fieldparam.unique_query) != "") {
        var query = this.fieldparam.unique_query.replace("[code]", data.target.value);
        this.mainService.postData("/executequery", { data: btoa(query) }).subscribe((result: any) => {
          if (result.status) {
            if (result.data.length != 0) {
              this.mainService.showmessaage("Duplicate Entry!!!, \"" + data.target.value + "\" Already exist.");
              this.fieldparam.isvalid = false;
            }
          } else {
            this.mainService.showmessaage("Please validate integrated query");
          }
        });
      }
    }

    // if(this.fieldparam.isu)
    this.afterchange.emit(data);
  }
  validatekeyupevent(data: any) {
    this.keyup.emit(data);
  }
  checkstatus(data: any) {
    if (data.target.checked) {
      this.fieldparam.value = 1;
    } else {
      this.fieldparam.value = 0;
    }
  } 
}
